import { safeDefine } from "../../registration/safe-define.js";
import { VolumeSliderElement } from "../../ui/volume-slider/element.js";
//#region src/define/ui/volume-slider.ts
safeDefine(VolumeSliderElement);
//#endregion

//# sourceMappingURL=volume-slider.js.map